/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type HelpHostDialog_viewer$ref = any;
export type NavbarComponent_viewer$ref = any;
export type NavbarComponent_viewer = {
    readonly id: string | null;
    readonly " $fragmentRefs": HelpHostDialog_viewer$ref;
    readonly " $refType": NavbarComponent_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "NavbarComponent_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "HelpHostDialog_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '458ef0101e074f3fae74deb24b4cf378';
export default node;
